export default (
  <svg xmlns="http://www.w3.org/2000/svg" width="44.424" height="43.149" viewBox="0 0 44.424 43.149">
    <path d="M64.552,12.078a2.936,2.936,0,0,0-.022,4.135L78.192,29.9H46.465a2.921,2.921,0,0,0,0,5.843h31.7L64.507,49.426a2.957,2.957,0,0,0,.022,4.135,2.909,2.909,0,0,0,4.112-.022L87.158,34.887h0a3.28,3.28,0,0,0,.607-.921,2.788,2.788,0,0,0,.225-1.124,2.929,2.929,0,0,0-.831-2.045L68.641,12.145A2.863,2.863,0,0,0,64.552,12.078Z" transform="translate(-43.566 -11.252)" fill="#f5ead1"/>
  </svg>
)
